// extracted by mini-css-extract-plugin
module.exports = {"card2Col":"style-module__card2Col___28vvI","card4Col":"style-module__card4Col___3MQXF","cardLink":"style-module__cardLink___3GRQp","checkbox":"style-module__checkbox___1O4rU"};